// Copyright 2019-2020 @Premiurly/polkassembly authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/* eslint-disable sort-keys */
import acalaLogo from 'src/assets/parachain-logos/acala-logo.jpg';
import acuityLogo from 'src/assets/parachain-logos/acuity-logo.jpg';
import altairLogo from 'src/assets/parachain-logos/altair-logo.jpeg';
import amplitudeLogo from 'src/assets/parachain-logos/amplitude-logo.png';
import astarLogo from 'src/assets/parachain-logos/astar-logo.png';
import automataLogo from 'src/assets/parachain-logos/automata-logo.jpg';
import basiliskLogo from 'src/assets/parachain-logos/basilisk-logo.jpg';
import pioneerLogo from 'src/assets/parachain-logos/bitcountrypioneer-logo.jpg';
import calamariLogo from 'src/assets/parachain-logos/calamari-logo.png';
import centrifugeLogo from 'src/assets/parachain-logos/centrifuge-logo.png';
import composableFinanceLogo from 'src/assets/parachain-logos/composable-finance-logo.png';
import crustLogo from 'src/assets/parachain-logos/crust-logo.svg';
import crustShadowLogo from 'src/assets/parachain-logos/crustshadow-logo.svg';
import equilibriumLogo from 'src/assets/parachain-logos/equilibrium.png';
import frequencyRococoLogo from 'src/assets/parachain-logos/frequency-logo.png';
import frequencyLogo from 'src/assets/parachain-logos/frequency-logo.png';
import gearLogo from 'src/assets/parachain-logos/gear-logo.jpg';
import genshiroLogo from 'src/assets/parachain-logos/genshiro.png';
import gmordieLogo from 'src/assets/parachain-logos/gmordie-logo.png';
import hydradxLogo from 'src/assets/parachain-logos/hydradx-logo.jpg';
import karuraLogo from 'src/assets/parachain-logos/karura-logo.jpg';
import khalaLogo from 'src/assets/parachain-logos/khala-logo.png';
import kiltLogo from 'src/assets/parachain-logos/kilt-logo.png';
import kusamaLogo from 'src/assets/parachain-logos/kusama-logo.gif';
import kylinLogo from 'src/assets/parachain-logos/kylin-logo.png';
import mantaLogo from 'src/assets/parachain-logos/manta-logo.jpg';
import moonbaseLogo from 'src/assets/parachain-logos/moonbase-logo.png';
import moonbeamLogo from 'src/assets/parachain-logos/moonbeam-logo.png';
import moonriverLogo from 'src/assets/parachain-logos/moonriver-logo.png';
import parallelLogo from 'src/assets/parachain-logos/parallel-logo.jpg';
import pendulumLogo from 'src/assets/parachain-logos/pendulum-logo.jpg';
import picassoLogo from 'src/assets/parachain-logos/picasso-logo.svg';
import pichiuLogo from 'src/assets/parachain-logos/pichiu-logo.png';
import polkadexLogo from 'src/assets/parachain-logos/polkadex-logo.jpg';
import polkadotLogo from 'src/assets/parachain-logos/polkadot-logo.jpg';
import polymeshLogo from 'src/assets/parachain-logos/polymesh-logo.png';
import robonomicsLogo from 'src/assets/parachain-logos/robonomics-logo.jpg';
import shidenLogo from 'src/assets/parachain-logos/shiden-logo.jpg';
import snowLogo from 'src/assets/parachain-logos/snow-logo.png';
import tanganikaLogo from 'src/assets/parachain-logos/tanganika-logo.png';
import tidechainLogo from 'src/assets/parachain-logos/tidechain-logo.svg';
import turingLogo from 'src/assets/parachain-logos/turing-logo.png';
import varaLogo from 'src/assets/parachain-logos/vara-logo.svg';
import westendLogo from 'src/assets/parachain-logos/westend-logo.jpg';
import xxcoinLogo from 'src/assets/parachain-logos/xxcoin-logo.svg';

import { ChainPropType } from '../types';

export const network = {
	POLKADOT: 'polkadot',
	KUSAMA: 'kusama',
	ACALA: 'acala',
	ACUITY: 'acuity',
	ALTAIR: 'altair',
	AMPLITUDE: 'amplitude',
	ASTAR: 'astar',
	AUTOMATA: 'automata',
	BASILISK: 'basilisk',
	CALAMARI: 'calamari',
	CENTRIFUGE: 'centrifuge',
	COMPOSABLE: 'composable',
	CRUST: 'crust',
	CRUSTSHADOW: 'crustshadow',
	EQUILIBRIUM: 'equilibrium',
	FREQUENCYROCOCO: 'frequency-rococo',
	FREQUENCY: 'frequency',
	GEAR: 'gear',
	GENSHIRO: 'genshiro',
	GMORDIE: 'gmordie',
	HEIKO: 'heiko',
	HYDRADX: 'hydradx',
	KARURA: 'karura',
	KHALA: 'khala',
	KILT: 'kilt',
	KYLIN: 'kylin',
	MANTA: 'manta',
	MOONBASE: 'moonbase',
	MOONBEAM: 'moonbeam',
	MOONRIVER: 'moonriver',
	PARALLEL: 'parallel',
	PENDULUM: 'pendulum',
	PICASSO: 'picasso',
	PICHIU: 'pichiu',
	PICHIUROCOCO: 'pichiu-rococo',
	PIONEER: 'pioneer',
	POLYMESH:'polymesh',
	POLYMESHTEST: 'polymesh-test',
	POLKADEX: 'polkadex',
	ROBONOMICS: 'robonomics',
	SHIBUYA: 'shibuya',
	SHIDEN: 'shiden',
	SNOW: 'snow',
	TANGANIKA: 'tanganika',
	TIDECHAIN: 'tidechain',
	TINKER: 'tinker',
	TURING: 'turing',
	VARA: 'vara',
	WESTEND: 'westend',
	XX: 'xx'
};

export const tokenSymbol = {
	ACA: 'ACA',
	ACU: 'ACU',
	AIR: 'AIR',
	AMPE: 'AMPE',
	ASTR: 'ASTR',
	ATA: 'ATA',
	BNC: 'BNC',
	BSX: 'BSX',
	CFG: 'CFG',
	CRU: 'CRU',
	CSM: 'CSM',
	DOL: 'DOL',
	DEV: 'DEV',
	DHX: 'DHX',
	DOT: 'DOT',
	FREN: 'FREN',
	FRQCY: 'FRQCY',
	GLMR: 'GLMR',
	HDX: 'HDX',
	HKO: 'HKO',
	ICZ: 'ICZ',
	KAR: 'KAR',
	KHA: 'KHA',
	KILT: 'KILT',
	KMA: 'KMA',
	KSM: 'KSM',
	KYL: 'KYL',
	LAYR: 'LAYR',
	MOVR: 'MOVR',
	NEER: 'NEER',
	PARA: 'PARA',
	PCHU: 'PCHU',
	PDEX: 'PDEX',
	PEN: 'PEN',
	PICA: 'PICA',
	POLYX: 'POLYX',
	SBY: 'SBY',
	SDN: 'SDN',
	TDFY: 'TDFY',
	TUR: 'TUR',
	WND: 'WND',
	XRT: 'XRT',
	UNIT: 'UNIT',
	VARA: 'VARA',
	XX: 'XX',
	TOKEN: 'TOKEN'
};

export const chainProperties: ChainPropType = {
	[network.POLKADOT]: {
		blockTime: 6000,
		category: 'polkadot',
		chainId: 0,
		logo: polkadotLogo,
		rpcEndpoint: 'wss://rpc.polkadot.io',
		ss58Format: 0,
		tokenDecimals: 10,
		tokenSymbol: tokenSymbol.DOT,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.KUSAMA]: {
		blockTime: 6000,
		category: 'kusama',
		chainId: 0,
		logo: kusamaLogo,
		rpcEndpoint: 'wss://kusama-rpc.polkadot.io',
		ss58Format: 2,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.KSM,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.ACALA]: {
		blockTime: 12000,
		category: 'test',
		chainId: 0,
		logo: acalaLogo,
		rpcEndpoint: 'wss://acala-polkadot.api.onfinality.io/public-ws',
		ss58Format: 10,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.ACA,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.ACUITY]: {
		blockTime: 6000,
		category: 'solo',
		chainId: 0,
		logo: acuityLogo,
		rpcEndpoint: 'wss://freemont.acuity.social',
		ss58Format: 42,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.ACU,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.ALTAIR]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 0,
		logo: altairLogo,
		rpcEndpoint: 'wss://altair.api.onfinality.io/public-ws',
		ss58Format: 136,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.AIR,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '100',
		treasuryProposalMaxBond:'500'
	},
	[network.AMPLITUDE]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 0,
		logo: amplitudeLogo,
		rpcEndpoint: 'wss://pencol-kua-01.pendulumchain.tech',
		ss58Format: 57,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.AMPE,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.ASTAR]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 592,
		logo: astarLogo,
		rpcEndpoint: 'wss://astar.api.onfinality.io/public-ws',
		ss58Format: 5,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.ASTR,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.AUTOMATA]: {
		blockTime: 6000,
		category: 'solo',
		chainId: 0,
		logo: automataLogo,
		rpcEndpoint: 'wss://api.ata.network',
		ss58Format: 2349,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.ATA,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '100',
		treasuryProposalMaxBond: null
	},
	[network.BASILISK]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 2090,
		logo: basiliskLogo,
		rpcEndpoint: 'wss://rpc.basilisk.cloud',
		ss58Format: 10041,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.BSX,
		treasuryProposalBondPercent: '3%',
		treasuryProposalMinBond: '10000',
		treasuryProposalMaxBond:'50000'
	},
	[network.PIONEER]: {
		blockTime: 12000,
		category: 'solo',
		chainId: 0,
		logo: pioneerLogo,
		rpcEndpoint: 'wss://pioneer.api.onfinality.io/public-ws',
		ss58Format: 268,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.NEER,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1',
		treasuryProposalMaxBond:'50'
	},
	[network.CALAMARI]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 2084,
		logo: calamariLogo,
		rpcEndpoint: 'wss://ws.calamari.systems/',
		ss58Format: 78,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.KMA,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.CENTRIFUGE]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 0,
		logo: centrifugeLogo,
		rpcEndpoint: 'wss://centrifuge-parachain.api.onfinality.io/public-ws',
		ss58Format: 36,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.CFG,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1000',
		treasuryProposalMaxBond:'5000'
	},
	[network.COMPOSABLE]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 0,
		logo: composableFinanceLogo,
		rpcEndpoint: 'wss://rpc.composable.finance',
		ss58Format: 49,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.LAYR,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '5',
		treasuryProposalMaxBond:'1000'
	},
	[network.CRUST]: {
		blockTime: 12000,
		category: 'solo',
		chainId: 0,
		logo: crustLogo,
		rpcEndpoint: 'wss://rpc.crust.network',
		ss58Format: 66,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.CRU,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.CRUSTSHADOW]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 0,
		logo: crustShadowLogo,
		rpcEndpoint: 'wss://rpc-shadow.crust.network',
		ss58Format: 66,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.CSM,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.EQUILIBRIUM]: {
		blockTime: 12000,
		category: 'test',
		chainId: 0,
		logo: equilibriumLogo,
		rpcEndpoint: 'wss://node.pol.equilibrium.io/',
		ss58Format: 68,
		tokenDecimals: 9,
		tokenSymbol: tokenSymbol.TOKEN,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.FREQUENCY]: {
		blockTime: 12000,
		category: 'test',
		chainId: 0,
		logo: frequencyLogo,
		rpcEndpoint: 'wss://0.rpc.frequency.xyz',
		ss58Format: 90,
		tokenDecimals: 8,
		tokenSymbol: tokenSymbol.FRQCY,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.FREQUENCYROCOCO]: {
		blockTime: 12000,
		category: 'test',
		chainId: 0,
		logo: frequencyRococoLogo,
		rpcEndpoint: 'wss://rpc.rococo.frequency.xyz/',
		ss58Format: 42,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.UNIT,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.GEAR]: {
		blockTime: 1000,
		category: 'solo',
		chainId: 0,
		logo: gearLogo,
		rpcEndpoint: 'wss://rpc-node.gear-tech.io:443',
		ss58Format: 42,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.UNIT,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.GENSHIRO]: {
		blockTime: 6000,
		category: 'test',
		chainId: 0,
		logo: genshiroLogo,
		rpcEndpoint: 'wss://testnet.genshiro.io',
		ss58Format: 67,
		tokenDecimals: 9,
		tokenSymbol: tokenSymbol.TOKEN,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.GMORDIE]: {
		blockTime: 9000,
		category: 'test',
		chainId: 0,
		logo: gmordieLogo,
		rpcEndpoint: 'wss://kusama.gmordie.com',
		ss58Format: 42,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.FREN,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.HEIKO]: {
		blockTime: 13000,
		category: 'kusama',
		chainId: 0,
		logo: parallelLogo,
		rpcEndpoint: 'wss://heiko-rpc.parallel.fi',
		ss58Format: 63,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.HKO,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.HYDRADX]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 0,
		logo: hydradxLogo,
		rpcEndpoint: 'wss://rpc.hydradx.cloud',
		ss58Format: 63,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.HDX,
		treasuryProposalBondPercent: '3%',
		treasuryProposalMinBond: '10000',
		treasuryProposalMaxBond:'50000'
	},
	[network.SNOW]: {
		blockTime: 12000,
		category: 'test',
		chainId: 0,
		logo: snowLogo,
		rpcEndpoint: 'wss://snow-rpc.icenetwork.io',
		ss58Format: 2207,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.ICZ,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '10',
		treasuryProposalMaxBond: null
	},
	[network.KARURA]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 0,
		logo: karuraLogo,
		rpcEndpoint: 'wss://karura.api.onfinality.io/public-ws',
		ss58Format: 8,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.KAR,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '5',
		treasuryProposalMaxBond:'25'
	},
	[network.KYLIN]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 0,
		logo: kylinLogo,
		rpcEndpoint: 'wss://polkadot.kylin-node.co.uk',
		ss58Format: 42,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.KYL,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.KHALA]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 0,
		logo: khalaLogo,
		rpcEndpoint: 'wss://khala.api.onfinality.io/public-ws',
		ss58Format: 30,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.KHA,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1',
		treasuryProposalMaxBond: null
	},
	[network.KILT]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 0,
		logo: kiltLogo,
		rpcEndpoint: 'wss://kilt-rpc.dwellir.com',
		ss58Format: 38,
		tokenDecimals: 15,
		tokenSymbol: tokenSymbol.KILT,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '20',
		treasuryProposalMaxBond: null
	},
	[network.MANTA]: {
		blockTime: 12000,
		category: 'solo',
		chainId: 1287,
		logo: mantaLogo,
		rpcEndpoint: 'wss://ws.rococo.dolphin.engineering',
		ss58Format: 78,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.DOL,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.MOONBASE]: {
		blockTime: 12000,
		category: 'test',
		chainId: 1287,
		logo: moonbaseLogo,
		rpcEndpoint: 'wss://moonbeam-alpha.api.onfinality.io/public-ws',
		ss58Format: 0,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.DEV,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1',
		treasuryProposalMaxBond: null
	},
	[network.MOONBEAM]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 1284,
		logo: moonbeamLogo,
		rpcEndpoint: 'wss://moonbeam.api.onfinality.io/public-ws',
		ss58Format: 1284,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.GLMR,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '100',
		treasuryProposalMaxBond: null
	},
	[network.MOONRIVER]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 1285,
		logo: moonriverLogo,
		rpcEndpoint: 'wss://moonriver.api.onfinality.io/public-ws',
		ss58Format: 1285,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.MOVR,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1',
		treasuryProposalMaxBond: null
	},
	[network.PARALLEL]: {
		blockTime: 12000,
		category: 'polkadot',
		chainId: 172,
		logo: parallelLogo,
		rpcEndpoint: 'wss://rpc.parallel.fi',
		ss58Format: 172,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.PARA,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1',
		treasuryProposalMaxBond:'5'
	},
	[network.PICASSO]: {
		blockTime: 12000,
		category: 'test',
		chainId: 0,
		logo: picassoLogo,
		rpcEndpoint: 'wss://picasso-rpc.composable.finance',
		ss58Format: 49,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.PICA,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '5000',
		treasuryProposalMaxBond:'10000'
	},
	[network.PICHIUROCOCO]: {
		blockTime: 12000,
		category: 'test',
		chainId: 172,
		logo: kylinLogo,
		rpcEndpoint: 'wss://pichiu-rococo-01.onebitdev.com',
		ss58Format: 42,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.PCHU,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '5',
		treasuryProposalMaxBond:'25'
	},
	[network.PICHIU]: {
		blockTime: 12000,
		category: 'test',
		chainId: 0,
		logo: pichiuLogo,
		rpcEndpoint: 'wss://kusama.kylin-node.co.uk',
		ss58Format: 42,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.PCHU,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '5',
		treasuryProposalMaxBond:'25'
	},
	[network.PENDULUM]: {
		blockTime: 6000,
		category: 'solo',
		chainId: 0,
		logo: pendulumLogo,
		rpcEndpoint: 'wss://rpc-pendulum.prd.pendulumchain.tech:443',
		ss58Format: 88,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.PEN,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.POLKADEX]: {
		blockTime: 12000,
		category: 'solo',
		chainId: 0,
		logo: polkadexLogo,
		rpcEndpoint: 'wss://polkadex.api.onfinality.io/public-ws',
		ss58Format: 88,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.PDEX,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: '100'
	},
	[network.POLYMESH]: {
		blockTime: 6000,
		category: 'solo',
		chainId: 0,
		logo: polymeshLogo,
		rpcEndpoint: 'wss://mainnet-rpc.polymesh.network',
		ss58Format: 12,
		tokenDecimals: 6,
		tokenSymbol: tokenSymbol.POLYX,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.POLYMESHTEST]: {
		blockTime: 6000,
		category: 'solo',
		chainId: 0,
		logo: polymeshLogo,
		rpcEndpoint: 'wss://testnet-rpc.polymesh.live',
		ss58Format: 42,
		tokenDecimals: 6,
		tokenSymbol: tokenSymbol.POLYX,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.ROBONOMICS]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 2048,
		logo: robonomicsLogo,
		rpcEndpoint: 'wss://robonomics.api.onfinality.io/public-ws',
		ss58Format: 32,
		tokenDecimals: 9,
		tokenSymbol: tokenSymbol.XRT,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '10',
		treasuryProposalMaxBond: null
	},
	[network.SHIBUYA]: {
		blockTime: 12000,
		category: 'test',
		chainId: 81,
		logo: shidenLogo,
		rpcEndpoint: 'wss://shibuya-rpc.dwellir.com',
		ss58Format: 5,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.SBY,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '100',
		treasuryProposalMaxBond: null
	},
	[network.SHIDEN]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 336,
		logo: shidenLogo,
		rpcEndpoint: 'wss://shiden.api.onfinality.io/public-ws',
		ss58Format: 5,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.SDN,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.TANGANIKA]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 336,
		logo: tanganikaLogo,
		rpcEndpoint: 'wss://tanganika-archive.datahighway.com/',
		ss58Format: 33,
		tokenDecimals: 18,
		tokenSymbol: tokenSymbol.DHX,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1',
		treasuryProposalMaxBond: null
	},
	[network.TIDECHAIN]: {
		blockTime: 12000,
		category: 'test',
		chainId: 336,
		logo: tidechainLogo,
		rpcEndpoint: 'wss://rpc.tidefi.io:443',
		ss58Format: 7007,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.TDFY,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1000',
		treasuryProposalMaxBond: '5000'
	},
	[network.TURING]: {
		blockTime: 12000,
		category: 'kusama',
		chainId: 2114,
		logo: turingLogo,
		rpcEndpoint: 'wss://turing-rpc.dwellir.com',
		ss58Format: 51,
		tokenDecimals: 10,
		tokenSymbol: tokenSymbol.TUR,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '1',
		treasuryProposalMaxBond: '5'
	},
	[network.VARA]: {
		blockTime: 2000,
		category: 'test',
		chainId: 0,
		logo: varaLogo,
		rpcEndpoint: 'wss://archive-rpc.vara-network.io',
		ss58Format: 137,
		tokenDecimals: 12,
		tokenSymbol: tokenSymbol.VARA,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '20',
		treasuryProposalMaxBond: null
	},
	[network.WESTEND]: {
		blockTime: 6000,
		category: 'test',
		chainId: 0,
		logo: westendLogo,
		rpcEndpoint: 'wss://kusama-rpc.polkadot.io',
		ss58Format: 0,
		tokenDecimals: 10,
		tokenSymbol: tokenSymbol.WND,
		treasuryProposalBondPercent: null,
		treasuryProposalMinBond: null,
		treasuryProposalMaxBond: null
	},
	[network.XX]: {
		blockTime: 6000,
		category: 'test',
		chainId: 0,
		logo: xxcoinLogo,
		rpcEndpoint: 'wss://xxnetwork-rpc.dwellir.com',
		ss58Format: 55,
		tokenDecimals: 9,
		tokenSymbol: tokenSymbol.XX,
		treasuryProposalBondPercent: '5%',
		treasuryProposalMinBond: '100',
		treasuryProposalMaxBond: null
	}
};

export const addressPrefix: Record<string, number> = {
	'kusama': 2,
	'moonbeam': 1284,
	'moonriver': 1285,
	'polkadot': 0
};
